//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'PeekCarousel',
  props: {
    items: {
      type: Array,
      required: true,
    },
    activeWidth: {
      type: Number,
      default: 432,
    },
    activeHeight: {
      type: Number,
      default: 243,
    },
    sideWidth: {
      type: Number,
      default: 329,
    },
    sideHeight: {
      type: Number,
      default: 185,
    },
    gap: {
      type: Number,
      default: 16,
    },
    interval: {
      type: Number,
      default: 7000,
    },
    autoplay: {
      type: Boolean,
      default: true,
    },
    // GA4計測用。'yasai' / 'gohan' など。未指定の場合は計測しない
    bannerType: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      activeIndex: 0,
      // 前後に2枚ずつクローンを足しているため、trackIndexはactiveIndexより2大きい
      // (1枚だけだと、クローン位置で停止する間だけそのさらに隣が存在せず一瞬空白になるため)
      trackIndex: 2,
      disableTransition: false,
      transitionDuration: 400, // CSSのtransition: transform 0.4s easeと合わせる
      timer: null,
      snapTimer: null,
      // ホバー中にクリック操作でstartAutoplayが呼ばれても再開しないようにするフラグ
      isHovering: false,
    }
  },
  computed: {
    // 先頭に末尾2枚の複製、末尾に先頭2枚の複製を足して、端でも隣が見えるようにする
    extendedItems() {
      const length = this.items.length

      if (length === 0) {
        return []
      }

      return [
        this.items[(length - 2 + length) % length],
        this.items[length - 1],
        ...this.items,
        this.items[0],
        this.items[1 % length],
      ]
    },
    trackStyle() {
      const offset =
        this.trackIndex * (this.sideWidth + this.gap) + this.activeWidth / 2

      return {
        transform: `translateX(${-offset}px)`,
        transition: this.disableTransition
          ? 'none'
          : `transform ${this.transitionDuration}ms ease`,
        // CSSの固定値(16px)を上書きし、位置計算に使うgapと実際の描画間隔を一致させる
        gap: `${this.gap}px`,
      }
    },
  },
  mounted() {
    this.startAutoplay()

    // mounted直後だとgtag.js側の初期化と競合することがあるため、
    // 1ティック遅らせてから送信する
    setTimeout(() => {
      if (!this.bannerType || !this.$gtag) {
        return
      }

      this.items.forEach((item, index) => {
        this.trackImpression(item, index)
      })
    }, 0)
  },
  beforeDestroy() {
    clearTimeout(this.timer)
    clearTimeout(this.snapTimer)
  },
  methods: {
    // request_banner.php の imgPath（例: images/banner/202610y_01.png）から
    // 月替わりでも一意になるバナーidを導出する（例: 202610y_01）
    bannerId(item) {
      const filename = item.imgPath.split('/').pop()

      return filename.replace(/\.[^.]+$/, '')
    },
    trackImpression(item, index) {
      this.$gtag.event('request_banner_impression', {
        request_banner_id: this.bannerId(item),
        request_banner_type: this.bannerType,
        request_banner_position: String(index),
        request_banner_version: 'carousel',
        request_banner_impression_value: 1,
      })
    },
    handleActiveClick(item) {
      // openInNewTabが真=外部リンクとして実遷移させるため、ページ内スクロールは発生させない
      if (!item.openInNewTab) {
        this.$emit('item-click', item)
      }

      if (!this.bannerType || !this.$gtag) {
        return
      }

      this.$gtag.event('request_banner_click', {
        request_banner_id: this.bannerId(item),
        request_banner_type: this.bannerType,
        request_banner_position: String(this.activeIndex),
        request_banner_version: 'carousel',
        request_banner_click_value: 1,
      })
    },
    // setIntervalではなく、進むたびに1回だけ次のタイマーを予約する方式にして
    // 手動操作直後に古いタイマーが紛れ込む余地をなくす
    startAutoplay() {
      clearTimeout(this.timer)

      // ホバー中はクリック操作由来のstartAutoplay呼び出しでも再開しない
      if (this.autoplay && !this.isHovering) {
        this.timer = setTimeout(this.next, this.interval)
      }
    },
    pauseAutoplay() {
      this.isHovering = true
      clearTimeout(this.timer)
    },
    resumeAutoplayOnLeave() {
      this.isHovering = false
      this.startAutoplay()
    },
    prev() {
      const length = this.items.length

      // 既にクローン位置を超えている状態で連打されると、trackIndexが配列範囲外まで
      // 進んで中央が空白になるため、先にアニメーション無しで実位置へ戻してから進める
      if (this.trackIndex <= 1) {
        this.snapInstantly()
      }

      this.activeIndex = (this.activeIndex - 1 + length) % length
      this.trackIndex -= 1

      if (this.trackIndex <= 1) {
        this.snapAfterTransition()
      }

      this.startAutoplay()
    },
    next() {
      const length = this.items.length

      if (this.trackIndex >= length + 2) {
        this.snapInstantly()
      }

      this.activeIndex = (this.activeIndex + 1) % length
      this.trackIndex += 1

      if (this.trackIndex >= length + 2) {
        this.snapAfterTransition()
      }

      this.startAutoplay()
    },
    goTo(index) {
      this.activeIndex = index
      this.trackIndex = index + 2
      this.startAutoplay()
    },
    // クローン位置まで滑ったら、アニメーション終了後に見た目を変えずに実位置へ戻す
    // (transitionendは子要素のサイズ変化ともバッティングするため使わず、
    //  CSSのtransition時間と同じ固定時間だけ待つ)
    snapAfterTransition() {
      clearTimeout(this.snapTimer)

      this.snapTimer = setTimeout(() => {
        this.snapToActiveIndex()
      }, this.transitionDuration)
    },
    // 既にクローン位置を超えた状態でprev/nextが呼ばれた場合に、アニメーション無しで
    // 即座に実位置へ戻す（連打でtrackIndexが配列範囲外に進み続けるのを防ぐ）
    snapInstantly() {
      clearTimeout(this.snapTimer)
      this.snapToActiveIndex()
    },
    snapToActiveIndex() {
      this.disableTransition = true
      // 呼び出し時点のactiveIndexから算出する（連打で古い値を使ってしまわないため）
      this.trackIndex = this.activeIndex + 2

      this.$nextTick(() => {
        const trackEl = this.$refs.track

        // 強制再描画してからtransitionを戻す
        if (trackEl) {
          // eslint-disable-next-line no-unused-expressions
          trackEl.offsetHeight
        }

        this.disableTransition = false
      })
    },
    onSideClick(extendedIndex) {
      const length = this.items.length

      if (extendedIndex < 2) {
        this.prev()
        return
      }
      if (extendedIndex > length + 1) {
        this.next()
        return
      }

      this.goTo(extendedIndex - 2)
    },
    itemStyle(index) {
      const isActive = index === this.trackIndex

      return {
        width: `${isActive ? this.activeWidth : this.sideWidth}px`,
        height: `${isActive ? this.activeHeight : this.sideHeight}px`,
        transition: this.disableTransition
          ? 'none'
          : `width ${this.transitionDuration}ms ease, height ${this.transitionDuration}ms ease`,
      }
    },
  },
}
